"use client";

import Header from "../../components/common/Header";
import { EyeOff, Camera, Trash2 } from "lucide-react";
import EyeOpen from "../../assets/icons/Eye.svg?react";
import User from "../../assets/icons/avatar.svg?react";
import Maya from "../../assets/icons/Maya Icon.svg?react";
import GCASH from "../../assets/icons/GCASH Icon.svg?react";
import { Link } from "react-router-dom";
import { Button, Checkbox, Label, TextInput } from "flowbite-react";
import { useState, useEffect } from "react";
import LinkGCashPopup from "../../components/Popup/LinkGCashPopup";
import LinkMayaPopup from "../../components/Popup/LinkMayaPopup";
import ConfirmationPopup from "../../components/Popup/ConfirmationPopup";
import SuccessPopup from "../../components/Popup/SuccessPopup";
import Avatar from "react-avatar";
import { userApi } from "../../api/user";
import { useAuth } from "../../context/AuthContext";
import Swal from "sweetalert2";

export default function Profile() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { user, tokens } = useAuth();

  const [gcashPopup, setGcashPopup] = useState(false);
  const [mayaPopup, setMayaPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);

  const [userInfo, setUserInfo] = useState({
    name: "",
    mobileNumber: "",
    password: "",
    ticketDisplayName: "",
  });

  useEffect(() => {
    if (user) {
      const fetchUserInfo = async () => {
        const updatedUserInfo = await userApi.getUserById(
          tokens.access.token,
          user.id,
        );
        // Extract mobile number for display (remove leading 63 or +63)
        let mobile = updatedUserInfo.data.user.mobileNumber || "";
        if (mobile.startsWith("+63")) {
          mobile = mobile.slice(3);
        } else if (mobile.startsWith("63")) {
          mobile = mobile.slice(2);
        }
        // If mobile starts with 9, keep as is; if starts with 09, remove leading 0
        if (mobile.startsWith("09")) {
          mobile = mobile.slice(1);
        }
        setUserInfo({
          name: updatedUserInfo.data.user.name || "",
          mobileNumber: mobile,
          ticketDisplayName: updatedUserInfo.data.user.ticketDisplayName || "",
        });
      };
      fetchUserInfo();
    }
  }, []);


  const updateUser = async () => {
    if (user && userInfo) {
      // Always save as 639... (Philippines)
      let mobile = userInfo.mobileNumber.replace(/\D/g, ""); // Remove non-digits
      if (mobile.startsWith("0")) {
        mobile = mobile.slice(1);
      }
      mobile = `63${mobile}`;
      const payload = {
        name: userInfo.name,
        mobileNumber: mobile,
        password: userInfo.password,
        ticketDisplayName: userInfo.ticketDisplayName,
        paymentsNumbers: [],
      };
      const updatedUser = await userApi.updateUser(
        user.id,
        tokens.access.token,
        payload
      );
      if (updatedUser.status === 200) {
        setUserInfo(updatedUser.data);
        Swal.fire({
          title: "Success",
          text: "User updated successfully",
          icon: "success",
        });
      }else{
        Swal.fire({
          title: "Error",
          text: updatedUser.data.message,
          icon: "error",
        });
      }
    }
  };


  return (
    <>
      <div className="min-h-screen  relative overflow-hidden ">
        <Header title="Profile" />
        {/* Content Section */}
        <div className="w-full ">
          <div className="flex items-center justify-center ">
            {/* avatar */}

            <div className="flex flex-col items-center gap-2 my-3">
              <div className="relative">
                <div className="w-24 h-24 rounded-full overflow-hidden bg-gray-100">
                  <Avatar
                    name={userInfo?.name}
                    size="100"
                    className="w-full h-full object-cover"
                  />
                </div>
                <label className="absolute bottom-0 right-0 p-1 bg-[#E1E7EF] rounded-full shadow cursor-pointer">
                  <Camera className="w-5 h-5 text-gray-600" />
                  <input type="file" className="hidden" accept="image/*" />
                </label>
              </div>
            </div>
          </div>

          {/* Login Form */}
          <form className="space-y-5 px-7">
            <div>
              <Label
                htmlFor="Name"
                className="block text-sm text-[#695C5C;] font-poppins ml-1 mb-2"
              >
                Full Name
              </Label>
              <TextInput
                id="Name"
                type="text"
                value={userInfo?.name}
                placeholder="Enter Your Name"
                className="w-full"
                onChange={(e) =>
                  setUserInfo({ ...userInfo, name: e.target.value })
                }
              />
            </div>
            <div>
              <Label
                htmlFor="Name"
                className="block text-sm text-[#695C5C;] font-poppins ml-1 mb-2"
              >
                Ticket Display Name
              </Label>
              <TextInput
                id="ticketDisplayName"
                type="text"
                value={userInfo?.ticketDisplayName}
                placeholder="Enter Your Ticket Display Name"
                className="w-full"
                onChange={(e) =>
                  setUserInfo({ ...userInfo, ticketDisplayName: e.target.value })
                }
              />  
            </div>
            <div>
              <Label
                htmlFor="phoneNumber"
                className="block text-sm text-[#695C5C;] font-poppins ml-1 mb-2"
              >
                Mobile Number{" "}
              </Label>
              <div className="flex gap-1">
                <select 
                  className="w-1/1 rounded-md border border-gray-300 p-2 bg-gray-50 text-sm focus:ring-blue-500 focus:border-blue-500"
                  value={"+63"}
                  disabled
                >
                  <option value="+63">+63</option>
                </select>
                <TextInput
                  containerClassName="w-full"
                  id="phoneNumber"
                  type="tel"
                  value={userInfo?.mobileNumber}
                  placeholder="Enter Your Mobile Number"
                  className="w-full"
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.startsWith("09")) {
                      value = value.slice(1);
                    }
                    if (value.length > 10) {
                      value = value.slice(0, 10);
                    }
                    setUserInfo({ ...userInfo, mobileNumber: value });
                  }}
                />
              </div>
            </div>
            <div>
              <Label
                htmlFor="email"
                className="block text-sm text-[#695C5C;] font-poppins ml-1 mb-2"
              >
                Email
              </Label>
              <TextInput
                id="email"
                type="email"
                value={userInfo?.email}
                disabled
                className="w-full"
                placeholder="Email Disabled"
              />
            </div>

            <div className="relative">
              <Label
                htmlFor="password"
                className="block text-sm text-[#695C5C;] font-poppins ml-1 mb-2"
              >
                Password
              </Label>
              <TextInput
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter Your Password"
                className="w-full"
                onChange={(e) =>
                  setUserInfo({ ...userInfo, password: e.target.value })
                }
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 "
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? (
                  <EyeOff className="h-5 w-5 text-gray-500" />
                ) : (
                  // <Eye className="h-5 w-5 text-gray-500" />

                  <EyeOpen className="w-full h-full object-cover" />
                )}
              </button>
            </div>

            {/* <div className="flex items-center gap-1">
              <button className={"bg-blue-50 text-blue-600"}>
                <GCASH width={60} height={47} className="rounded-lg" />
              </button>
              <TextInput
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter Your Password"
                className="w-full"
              />
              <button type="button" variant="outline" size="icon">
                <Trash2
                  className="text-[#9EACC0] w-5 h-6"
                  onClick={() => setDeletePopup(true)}
                />
              </button>
            </div>

            <div className="flex items-center justify-center gap-3 ">
              <span className="text-sm font-normal"> Add Payment Number</span>

              <GCASH
                width={60}
                height={47}
                className="object-cover"
                onClick={() => setGcashPopup(true)}
              />

              <Maya
                width={60}
                height={47}
                className="object-cover"
                onClick={() => setMayaPopup(true)}
              />
            </div> */}

            <Button
              type="button"
              style={{ marginTop: "40px", marginBottom: "40px" }}
              className="w-full bg-[#0E64D1] hover:bg-blue-900 text-white text-base font-semibold rounded-md"
              onClick={updateUser}
            >
              Save Changes
            </Button>
          </form>
        </div>
      </div>

      <LinkGCashPopup
        isOpen={gcashPopup}
        onClose={() => setGcashPopup(false)}
      />

      <LinkMayaPopup isOpen={mayaPopup} onClose={() => setMayaPopup(false)} />

      <ConfirmationPopup
        isOpen={deletePopup}
        onClose={() => setDeletePopup(false)}
      />

      <SuccessPopup
        isOpen={successPopup}
        onClose={() => setSuccessPopup(false)}
      />
    </>
  );
}
